import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ShellComponent } from './shell/shell.component';
import { AppMenuComponent, AppSubMenuComponent } from './shell/app-menu/app-menu.component';
import { TableModule } from 'primeng/table';
import { PanelModule } from 'primeng/panel';
import { ButtonModule } from 'primeng/button';
import { DropdownModule } from 'primeng/dropdown';
import { InputTextModule } from 'primeng/inputtext';
import { BlockUIModule } from 'primeng/blockui';
import { CalendarModule } from 'primeng/calendar';
import { CheckboxModule } from 'primeng/checkbox';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DialogModule } from 'primeng/dialog';
import { TabViewModule } from 'primeng/tabview';
import { FieldsetModule } from 'primeng/fieldset';
import { FormsModule, } from '@angular/forms';
import { ScrollPanelModule } from 'primeng/scrollpanel';
import { AppFooterComponent } from './shell/app-footer/app-footer.component';
import { AppTopBarComponent } from './shell/app-tool-bar/app.topbar.component';
import { DashboardDemoComponent } from './shell/app-dashboard/dashboarddemo.component';
import { RouterModule } from '@angular/router';
import { ProgressBarModule } from 'primeng/progressbar';

@NgModule({
  imports: [
    RouterModule,
    CommonModule,
    DropdownModule,
    PanelModule, 
    ButtonModule, 
    DialogModule,
     FieldsetModule,
    InputTextModule, 
    CheckboxModule,
    BlockUIModule, 
    CalendarModule, 
    ConfirmDialogModule,
    FormsModule, ScrollPanelModule,
    TabViewModule, 
    ProgressBarModule
  ],
  declarations: [ShellComponent, AppSubMenuComponent,
    AppMenuComponent,
    AppTopBarComponent,
    AppFooterComponent,
    DashboardDemoComponent
  ],
  exports: [ShellComponent],
  providers: [
  ]

})
export class ViewModule { }
